<template>
  <div class="statement-react">
    <jybe-nonauth-button v-bind:statement="statement" />
    <login-button v-bind:text="'Login to react'" />
    <share-button v-bind:type="'statements'" v-bind:id="statement.id" />
  </div>
</template>

<script>
  import StatementNonauth from "./StatementNonauth.ts";

  export default StatementNonauth
</script>
